<div class="section-list card">
    <div class="card-header">
        <nav class="navbar navbar-expand-sm navbar-light navbar-section-header justify-content-between section-header">
            <span class="navbar-brand mb-0 h1"><i class="fas fa-th-large mr-1"></i> Panel types</span>
            <div class="collapse navbar-collapse" id="navbarSupportedContent">
                <div class="ml-auto d-flex justify-content-end">
                    <ul class="nav navbar-nav ml-auto">
<!--                         <li class="nav-item" *permusr="controlEnum.BTN_SITE_EDIT">
                            <a class="nav-link" role="button" (click)="newPanel();false">
                                <i class="far fa-plus-square"></i> New Panel
                            </a>
                        </li> -->
                        <li class="nav-item">
                            <a class="nav-link" role="button" (click)="refresh();false">
                                <i class="fas fa-sync"></i>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
    </div>
    <div class="card-body">
        <mat-progress-bar mode="indeterminate" *ngIf="loadinglist"></mat-progress-bar>
        <app-frms-messagebar *ngIf="alertmessage" [alertmessage]="alertmessage"></app-frms-messagebar>
        <perfect-scrollbar style="max-height: 550px;">
            <table mat-table #table [dataSource]="dataSource" matSort
                class="table table-hover table-striped frms-table table-align-middle">
                <ng-container matColumnDef="id">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-header-id mat-uuid"> Id </th>
                    <td mat-cell *matCellDef="let row" class="table-header-id mat-uuid">
                        {{row.id}}
                    </td>
                </ng-container>
                
                <ng-container matColumnDef="brand">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Manufacturer </th>
                    <td mat-cell *matCellDef="let row">
                        {{row.brand}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="model">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Model </th>
                    <td mat-cell *matCellDef="let row">
                        {{row.model}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="serial">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Serial </th>
                    <td mat-cell *matCellDef="let row">
                        {{row.serial}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="type">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Type </th>
                    <td mat-cell *matCellDef="let row">
                        {{row.type}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="power">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Power(W) </th>
                    <td mat-cell *matCellDef="let row">
                        {{row.electrical?.power}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="efficiency">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Efficiency </th>
                    <td mat-cell *matCellDef="let row">
                        {{row.electrical?.efficency}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="vmp">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Vmp </th>
                    <td mat-cell *matCellDef="let row">
                        {{row.electrical?.Vmp}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="voc">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Voc </th>
                    <td mat-cell *matCellDef="let row">
                        {{row.electrical?.Voc}}
                    </td>
                </ng-container>
<!--                 <ng-container matColumnDef="datasheet">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>DataSheet </th>
                    <td mat-cell *matCellDef="let row" class="pl-5">
                        <a *ngIf="hasDatasheet(row)" target="_blank" href="{{row.info.datasheet}}"
                            matTooltip="{{row.info.datasheet}}">
                            <i class="far fa-file-alt"></i></a>
                    </td>
                </ng-container> -->
                <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef> </th>
                    <td mat-cell *matCellDef="let row" (click)="$event.stopPropagation()">
                        <div class="td-actions text-right">
                            <button type="button" class="btn btn-sm btn-outline-secondary" [matMenuTriggerFor]="menu">
                                <i class="fas fa-ellipsis-v"></i>
                            </button>
                            <mat-menu #menu="matMenu" class="">
<!--                                 <div mat-menu-item
                                    *permusr="{id:controlEnum.BTN_SITE_EDIT, authFunction:acl_btn_bysite(controlEnum.BTN_SITE_EDIT,site)}">
                                    <a class="dropdown-item" [routerLink]="" (click)="addpdfsheet(row)"
                                        matTooltip="Add documentation to panel">
                                        <i class="fa-plus-square far"></i> Add PDF sheet</a>
                                </div> -->
                                <div mat-menu-item
                                    *permusr="{id:controlEnum.BTN_SITE_EDIT, authFunction:acl_btn_bysite(controlEnum.BTN_SITE_EDIT,site)}">
                                    <a class="dropdown-item text-danger" [routerLink]=""
                                        (click)="openDialogDeletePanel(row)">
                                        <i class="far fa-trash-alt"></i> Delete
                                    </a>
                                </div>
                            </mat-menu>
                        </div>
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky: true" class="thead-dark"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
        </perfect-scrollbar>

        <mat-paginator [pageSizeOptions]="[20,50,100,200]" showFirstLastButtons></mat-paginator>
    </div>

</div>